<template>
  <div class="circle-wrap" :class="size">
    <span class="circle-bg" :style="{ 'background-color': bg }"
      ><i class="circle-icon" :class="icon" :style="{ color: color }"></i
    ></span>
    <span v-if="label" class="label">{{ label }}</span>
    <slot v-else></slot>
  </div>
</template>

<script>
export default {
  name: 'circle-icon',
  props: {
    icon: {
      type: String,
      required: true,
    },
    bg: {
      type: String,
      default: '#fff7e6',
    },
    color: {
      type: String,
      default: '#ffa940',
    },
    size: {
      type: String,
      default: 'xs',
      validator(value) {
        return ['xs', 'sm', 'md', 'lg', 'xl'].indexOf(value) > -1
      },
    },
    label: String,
  },
  data() {
    return {}
  },
  computed: {},
}
</script>

<style lang="less" scoped>
.circle-wrap,
.circle-bg {
  display: inline-block;
}
.circle-bg {
  padding: 5px 6px;
  border-radius: 50%;
}
.label {
  color: #808695;
  font-size: 14px;
  margin-left: 4px;
}

.circle-wrap {
  &.xs {
    .circle-bg {
      padding: 5px 6px;
    }
    .circle-icon {
      font-size: 12px;
    }
  }

  &.sm {
    .circle-bg {
      padding: 6px 6px 5px;
    }
    .circle-icon {
      font-size: 14px;
    }
  }

  &.md {
    .circle-bg {
      padding: 6px 7px 7px;
    }
    .circle-icon {
      font-size: 16px;
    }
  }
  &.lg {
    .circle-bg {
      padding: 6px 7px 7px;
    }
    .circle-icon {
      font-size: 18px;
    }
  }
}
</style>